export const RESOURCES = {
  devotions: {
    title: "Renungan", eyebrow: "Konten Harian",
    fields: [
      ["title", "Judul", "text"], ["date", "Tanggal", "date"], ["verse", "Ayat", "text"], ["verse_text", "Isi Ayat", "textarea"],
      ["content", "Isi Renungan", "richtext"], ["author", "Penulis", "text"], ["image_url", "Gambar", "image"],
    ],
    columns: ["date", "title", "verse", "author"],
  },
  events: {
    title: "Events", eyebrow: "Agenda Gereja",
    fields: [
      ["title", "Judul", "text"], ["description", "Deskripsi", "textarea"],
      ["category", "Kategori", "select", ["ibadah", "youth", "retreat", "umum"]],
      ["start_date", "Tanggal", "date"], ["time", "Jam", "time"], ["location", "Lokasi", "text"],
      ["price", "Biaya (0 = Gratis)", "number"], ["quota", "Kuota (0 = tanpa batas)", "number"],
      ["special", "Event Khusus (tampil sebagai banner)", "bool"], ["banner_text", "Teks Banner (opsional)", "text"],
      ["no_registration", "Tanpa registrasi (poster/gambar ibadah saja)", "bool"],
      ["public_ticketing", "Tiketing Publik (tampil di menu Event website, tamu tanpa NIG bisa daftar/beli tiket)", "bool"],
      ["ticket_types", "Jenis Tiket — 1 baris = Nama|Harga|Kuota (mis. Reguler|0|100)", "textarea"],
      ["image_url", "Gambar Website — landscape 1200×630 px (16:9)", "image"],
      ["image_url_portal", "Gambar Portal Jemaat — potret/persegi 1080×1080 px", "image"],
      ["published", "Tampilkan", "bool"],
    ],
    columns: ["start_date", "title", "category", "location"],
    defaults: { category: "umum", price: 0, quota: 0, published: true },
  },
  schedules: {
    title: "Jadwal Ibadah", eyebrow: "Ibadah Mingguan",
    fields: [
      ["title", "Nama Ibadah", "text"], ["category", "Kategori", "select", ["Umum", "Youth", "Kids"]],
      ["day", "Hari (contoh: Minggu Pagi)", "text"], ["time", "Jam", "time"], ["location", "Lokasi", "text"], ["order", "Urutan", "number"],
    ],
    columns: ["order", "title", "day", "time", "location"],
    defaults: { category: "Umum", order: 1 },
  },
  grow_classes: {
    title: "Grow Track", eyebrow: "Kelas Pemuridan",
    fields: [["code", "Kode", "text"], ["title", "Judul", "text"], ["description", "Deskripsi", "textarea"], ["sessions", "Jumlah Sesi", "number"], ["order", "Urutan", "number"]],
    columns: ["order", "code", "title", "sessions"],
    defaults: { sessions: 4, order: 1 },
  },
  komsels: {
    title: "Relationship Community", eyebrow: "RC & TTS Community",
    fields: [
      ["name", "Nama Komunitas", "text"],
      ["type", "Jenis", "select", ["rc", "tts"]],
      ["category", "Kategori", "category_select"],
      ["description", "Deskripsi", "textarea"],
      ["area", "Area", "text"], ["day", "Hari", "text"], ["time", "Jam", "time"],
      ["leader", "Pemimpin", "text"], ["leader_nig", "NIG Leader (agar pendaftaran masuk ke leader)", "text"],
      ["contact", "Kontak", "text"],
    ],
    columns: ["name", "type", "category", "area", "day", "leader"],
    defaults: { type: "rc" },
  },
  community_categories: {
    title: "Kategori Komunitas", eyebrow: "RC & TTS Community",
    fields: [
      ["name", "Nama Kategori", "text"],
      ["type", "Untuk Jenis", "select", ["rc", "tts"]],
      ["description", "Keterangan", "text"], ["order", "Urutan", "number"],
    ],
    columns: ["order", "name", "type", "description"],
    defaults: { type: "tts", order: 1 },
  },
  welcome_media: {
    title: "Media Layar Sapa", eyebrow: "Layar Sapa Jemaat",
    fields: [
      ["title", "Judul Slide", "text"],
      ["kind", "Jenis", "select", ["image", "video"]],
      ["image_url", "Gambar (untuk jenis image)", "image"],
      ["youtube_url", "Link YouTube (untuk jenis video)", "text"],
      ["caption", "Keterangan", "text"], ["order", "Urutan", "number"], ["active", "Aktif", "bool"],
    ],
    columns: ["order", "title", "kind", "active"],
    defaults: { kind: "image", active: true, order: 1 },
  },
  ministries: {
    title: "Divisi Pelayanan", eyebrow: "My Ministry",
    fields: [["name", "Nama Divisi", "text"], ["description", "Deskripsi", "text"], ["leader", "Koordinator", "text"], ["roles", "Daftar Role (pisahkan koma)", "textarea"]],
    columns: ["name", "leader", "roles"],
  },
  gallery: {
    title: "Galeri", eyebrow: "Media Pelayanan",
    fields: [["image_url", "Gambar", "image"], ["caption", "Keterangan", "text"]],
    columns: ["image_url", "caption"],
  },
  sermons: {
    title: "Sermon", eyebrow: "Khotbah YouTube",
    fields: [
      ["title", "Judul Khotbah", "text"], ["speaker", "Pembicara", "text"], ["series", "Seri (opsional)", "text"],
      ["date", "Tanggal", "date"], ["youtube_url", "Link YouTube", "text"],
      ["description", "Deskripsi", "textarea"], ["published", "Tampilkan di website", "bool"],
    ],
    columns: ["date", "title", "speaker", "series"],
    defaults: { published: true },
  },
  serve_questions: {
    title: "Form Serve-Up", eyebrow: "Pertanyaan Pendaftaran",
    fields: [
      ["label", "Pertanyaan", "text"],
      ["type", "Jenis Jawaban", "select", ["text", "textarea", "select"]],
      ["options", "Pilihan (pisahkan koma, untuk jenis select)", "textarea"],
      ["placeholder", "Placeholder (opsional)", "text"],
      ["order", "Urutan", "number"], ["required", "Wajib dijawab", "bool"], ["active", "Aktif", "bool"],
    ],
    columns: ["order", "label", "type", "required"],
    defaults: { type: "text", required: false, active: true, order: 1 },
  },
};
